import FlashLib from 'flashlib_onlyplay';

export default class ControllerSymbolsBlock extends FlashLib.MovieClip{
  constructor(data, displayItemData) {
    super(data, displayItemData);
    this.blocks = [];
    this.children.forEach((block) => {
      const type = block.name.match(/\d?\d$/);
      this.blocks[+type] = block;
    })
    this.changeType(2);
  }

  changeSymbol(reelSymbolsArray) {
    const type = reelSymbolsArray.length;
    this.changeType(type); // set symbols type
    this.symbols.forEach( (symbol, index) => symbol.changeSymbol(reelSymbolsArray[index], null, type));
  }

  changeType(type) {
    if (type === this.type) return;
    this.type = type;
    this.activeBlock = this.blocks[this.type];
    this.blocks.forEach(block => {
      if (block === this.activeBlock) return;
      block.children.forEach(symbol => {
        symbol.stopAnimation();
      });
      block.visible = false;
    });
    this.activeBlock.visible = true;
    this.symbols = [ ...this.activeBlock.children ]
  }

  stopAnimation() {
    this.symbols.forEach( (symbol) => symbol.stopAnimation());
  }

  setActive(value) {
    this.symbols.forEach( (symbol) => symbol.setActive(value));
  }
}
